import AddBonanzaPointDialog from './addBonanzaPointDialog.container'

export default AddBonanzaPointDialog